import { connect }        from 'react-redux';
import Locale             from '../../../locale';
import Errors             from '../../../errors';
import SuccessString      from '../../../success';
import {
    dismissError,
    dismissAllErrors }     from '../../../errors-dux';
import { dismissSuccess }  from '../../../success-dux';
import { fetchBundleData } from '../../../client-dux';
import {
    setUserLocale,
    changePassword,
} from './profile-dux';
import Profile from './profile.jsx';

export default connect(
    // mapStateToProps
    state => ( {
        user: state.userData,
        passwordRules: state.clientData.passwordRules,
        localeOptions: state.clientData.localeList,
        locale: state.userData.locale,
        busyChangingPassword: state.profileData.busyChangingPassword,
        passwordChangeSuccess: state.successData.done,
        busyUserLocale: state.profileData.busyUserLocale,
        changePwdErrors: Errors.getByType( state, Errors.ERROR_PROFILE_CHANGEPASSWORD ),
        changePwdSuccessMessage: SuccessString.getByType( state, SuccessString.SUCCESS_PROFILE_CHANGEPASSWORD ),
        changeLocaleSuccessMessage: SuccessString.getByType( state, SuccessString.SUCCESS_PROFILE_SETUSERLOCALE ),
        changeLocaleErrors: Errors.getByType( state, Errors.ERROR_PROFILE_SETUSERLOCALE ),
        passwordRequirements: Locale.getString( state, 'common.passwordRules.requirementsLabel' ),
        passwordLabels: {
            isLowerCaseRequired: Locale.getString( state, 'common.passwordRules.lowercaseLabel' ),
            isUpperCaseRequired: Locale.getString( state, 'common.passwordRules.uppercaseLabel' ),
            isSpecialCharRequired: Locale.getString( state, 'common.passwordRules.specialCharacterLabel' ),
            isNumberRequired: Locale.getString( state, 'common.passwordRules.numberLabel' ),
            length: Locale.getString( state, 'common.passwordRules.lengthLabel', {
                minLength: state.clientData.passwordRules.minLength,
                maxLength: state.clientData.passwordRules.maxLength
            } )
        },
        hidePasswordFields: state.ssoAuthenticated.ssoType === 'sso_only',
        bundleList: state.clientData.bundleList
    } ),
    // mapDispatchToProps
    {
        dismissSuccess,
        dismissError,
        dismissAllErrors,
        changePassword,
        fetchBundleData,
        setUserLocale
    }
)( Profile );
